import { createContext, useContext, useState, useEffect } from 'react'

const AuthContext = createContext(null)

const AUTH_API = '/api/auth'

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('sanajim_jwt'))
  const [loading, setLoading] = useState(true)

  // Auto-verify token on load
  useEffect(() => {
    const stored = localStorage.getItem('sanajim_jwt')
    if (!stored) {
      setLoading(false)
      return
    }

    // Verify with backend
    fetch(`${AUTH_API}/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: stored }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setToken(stored)
        } else {
          localStorage.removeItem('sanajim_jwt')
          setToken(null)
        }
      })
      .catch(() => {
        // If backend is down, check JWT expiry locally as fallback
        try {
          const parts = stored.split('.')
          if (parts.length === 3) {
            const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
            if (payload.exp && payload.exp > Math.floor(Date.now() / 1000)) {
              setToken(stored)
            } else {
              localStorage.removeItem('sanajim_jwt')
              setToken(null)
            }
          }
        } catch {
          localStorage.removeItem('sanajim_jwt')
          setToken(null)
        }
      })
      .finally(() => setLoading(false))
  }, [])

  const login = async (username, password) => {
    try {
      const res = await fetch(`${AUTH_API}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      })

      const data = await res.json()

      if (data.success && data.token) {
        localStorage.setItem('sanajim_jwt', data.token)
        setToken(data.token)
        return { success: true }
      }

      return { success: false, error: data.error || 'خطأ غير معروف' }
    } catch {
      return { success: false, error: 'فشل الاتصال بالخادم' }
    }
  }

  const logout = () => {
    localStorage.removeItem('sanajim_jwt')
    setToken(null)
  }

  return (
    <AuthContext.Provider value={{ token, login, logout, loading, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
